export default __webpack_public_path__ + "static/media/ic_setting.a9a3f792.svg";